import { resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, createTextVNode as _createTextVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-61604ee0"),n=n(),_popScopeId(),n)
const _hoisted_1 = /*#__PURE__*/_createTextVNode("数量限制")
const _hoisted_2 = /*#__PURE__*/_createTextVNode("大小限制")

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_el_input = _resolveComponent("el-input")!
  const _component_el_form_item = _resolveComponent("el-form-item")!
  const _component_tip = _resolveComponent("tip")!
  const _component_el_input_number = _resolveComponent("el-input-number")!
  const _component_el_switch = _resolveComponent("el-switch")!

  return (_openBlock(), _createElementBlock("div", null, [
    _createVNode(_component_el_form_item, { label: "提示文字" }, {
      default: _withCtx(() => [
        _createVNode(_component_el_input, {
          modelValue: _ctx._placeholder,
          "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx._placeholder) = $event)),
          size: "default",
          placeholder: "请设置提示语"
        }, null, 8, ["modelValue"])
      ]),
      _: 1
    }),
    _createVNode(_component_el_form_item, { label: "数量限制" }, {
      label: _withCtx(() => [
        _createVNode(_component_tip, { content: "限制最大上传图片数量（为0则不限制）" }, {
          default: _withCtx(() => [
            _hoisted_1
          ]),
          _: 1
        })
      ]),
      default: _withCtx(() => [
        _createVNode(_component_el_input_number, {
          modelValue: _ctx._value.maxNumber,
          "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx._value.maxNumber) = $event)),
          class: "max-fill",
          "controls-position": "right",
          precision: 0,
          size: "default",
          placeholder: "最多上传几张图片"
        }, null, 8, ["modelValue"])
      ]),
      _: 1
    }),
    _createVNode(_component_el_form_item, { label: "大小限制" }, {
      label: _withCtx(() => [
        _createVNode(_component_tip, { content: "限制单个图片最大大小-MB（为0则不限制）" }, {
          default: _withCtx(() => [
            _hoisted_2
          ]),
          _: 1
        })
      ]),
      default: _withCtx(() => [
        _createVNode(_component_el_input_number, {
          modelValue: _ctx._value.maxSize,
          "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_ctx._value.maxSize) = $event)),
          class: "max-fill",
          "controls-position": "right",
          precision: 1,
          size: "default",
          placeholder: "单个文件最大大小"
        }, null, 8, ["modelValue"])
      ]),
      _: 1
    }),
    _createVNode(_component_el_form_item, { label: "图片压缩" }, {
      default: _withCtx(() => [
        _createVNode(_component_el_switch, {
          modelValue: _ctx._value.enableZip,
          "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((_ctx._value.enableZip) = $event))
        }, null, 8, ["modelValue"])
      ]),
      _: 1
    })
  ]))
}